module.exports = __webpack_public_path__ + "img/04.dcbaad36.png";